import React, { useEffect } from 'react';
//import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import './App.css';
import Sidebar from './Sidebar';
import Chat from './Chat';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import Login from './Login';
import {useStateValue} from './StateProvider';
import Hello from './Hello';
import {auth} from './firebase';
import {actionTypes} from './reducer';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  drawerPaper: {
    position:'relative',
    width: drawerWidth,
  },
}));

function App() {
  const classes = useStyles();
  //const [user,setUser] = useState(null);
  const [{user},dispatch] = useStateValue(); //retreive user object from redux data layer

  useEffect(()=>{
    auth.onAuthStateChanged(authUser => {
       if (authUser) { dispatch({ type:actionTypes.SET_USER,user:authUser});}
    })
  },[dispatch]);

  return (
    <div className='app'>
      <Router>
        {!user ? (<Login />) : (
        <>
        <Header />
        <div className="app__body">
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
          <Sidebar />
          </Drawer>
        </Hidden>

          <Switch>
          	<Route path='/room/:roomId' component={Chat} />
          	<Route path='/' component={Hello} />
          </Switch>
        </div>
        </>
        )}
      </Router>
    </div>
    );
}

export default App;